export default __webpack_public_path__ + "static/media/nicknameShuimo.a829bba9.png";